import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'react-bootstrap5';
import { Formik, Form as FormikForm } from 'formik';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Alert from 'components/new_ui/Alerts/alert';
import HorizontalFileField from 'components/new_ui/Form/HorizontalFileField';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import CheckboxField from 'components/new_ui/Form/CheckboxField';
import ColorField from 'components/new_ui/Form/ColorField';
import useBusinessSizes from 'components/Common/BusinessSizes/Hooks/useBusinessSizes';
import useIndustries from 'components/Common/Industries/Hooks/useIndustries';
import { useContext } from 'components/Managers/Setup/Context';

export default function BasicInformation() {
  const { state, dispatch, actions } = useContext();
  const [loading, setLoading] = useState(true);
  const { loading: loadingBusinessSizes, businessSizes } = useBusinessSizes();
  const { loading: loadingIndustries, industries } = useIndustries();

  const businessSizesOptions = businessSizes.map((businessSize) => (
    { label: businessSize.attributes.title, value: businessSize.id }
  ));

  const industriesOptions = industries.map((industry) => (
    { label: industry.attributes.title, value: industry.id }
  ));

  useEffect(() => {
    actions.loadEnterprise(
      dispatch,
      state.enterpriseId,
      () => setLoading(false),
    );
  }, []);

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    actions.updateEnterprise(
      dispatch,
      state.enterpriseId,
      values,
      () => {
        setSubmitting(false);
        Alert({
          text: 'Successfully updated company data!',
          confirmButtonText: 'Close',
        }).then((_result) => {
          window.location.reload(false);
        });
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <>
      <section className="pb-4">
        <h4>Basic Information</h4>
      </section>

      {loading || loadingBusinessSizes || loadingIndustries ? (
        <LoadingPlaceholder text="Loading..." className="py-5" />
      ) : (
        <Formik
          initialValues={{
            name: state.enterpriseName,
            company_size_id: state.enterpriseSizeId,
            industry_ids: state.enterpriseIndustryIds,
            logo: state.enterpriseLogo,
            primary_color: state.enterpriseColor || '#000000',
            branding_available: state.enterpriseBrandingAvailable,
          }}
          onSubmit={onSubmitHundler}
        >
          {({ isSubmitting }) => (
            <FormikForm className="needs-validation" noValidate="">
              <section className="pt-0 border-0">
                <Row>
                  <Col md="6">
                    <HorizontalFileField
                      name="logo"
                      label="Company Logo"
                    />
                    <ColorField
                      id="primary-color"
                      name="primary_color"
                      label="Company Color"
                      hint="Click the box to select the primary branding color."
                    />
                    <CheckboxField
                      id="branding-available"
                      name="branding_available"
                      label="Activate Branding Options"
                    />
                  </Col>

                  <Col md="6">
                    <HorizontalTextField name="name" label="Company Name" disabled />
                    <HorizontalSelectField name="company_size_id" label="Company Size" options={businessSizesOptions} />
                    <HorizontalSelectField name="industry_ids" label="Industry" options={industriesOptions} isMulti />
                  </Col>
                </Row>
              </section>

              <footer>
                <Button
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting && (
                    <LoadingPlaceholder placement="inline" text=" " />
                  )}
                  Save
                </Button>
              </footer>
            </FormikForm>
          )}
        </Formik>
      )}
    </>
  );
}
